/**
 * Role-based access control for Verify Goods admin panel.
 *
 * super_admin — platform operator (manages brands, global settings)
 * brand_admin — brand portal login (scoped to one brand)
 */

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  BRAND_ADMIN: 'brand_admin',
};

export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard.view',
  BRANDS_MANAGE: 'brands.manage',
  BRANDS_VIEW: 'brands.view',
  VERIFICATION_VIEW: 'verification.view',
  VERIFICATION_MANAGE: 'verification.manage',
  SETTINGS_VIEW: 'settings.view',
};

const ALL_PERMISSIONS = Object.values(PERMISSIONS);

const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: ALL_PERMISSIONS,
  [ROLES.BRAND_ADMIN]: [
    PERMISSIONS.DASHBOARD_VIEW,
    PERMISSIONS.VERIFICATION_VIEW,
    PERMISSIONS.VERIFICATION_MANAGE,
    PERMISSIONS.SETTINGS_VIEW,
  ],
};

/** Map API / DB role values to panel roles. */
export function normalizeRole(role) {
  if (!role) return null;
  if (role === 'admin') return ROLES.BRAND_ADMIN;
  return role;
}

export function getPermissionsForRole(role) {
  const panelRole = normalizeRole(role) || role;
  return ROLE_PERMISSIONS[panelRole] || [];
}

export function roleHasPermission(role, permission) {
  if (!role || !permission) return false;
  return getPermissionsForRole(role).includes(permission);
}

export function roleHasAnyPermission(role, permissions = []) {
  return permissions.some((p) => roleHasPermission(role, p));
}

export function roleLabel(role) {
  switch (role) {
    case ROLES.SUPER_ADMIN:
      return 'Super Admin';
    case ROLES.BRAND_ADMIN:
      return 'Brand Admin';
    default:
      return 'User';
  }
}

export function loginPortalForRole(role) {
  return role === ROLES.BRAND_ADMIN ? 'brand' : 'super';
}
